<template>
    <div class="baby-or-adoption-home-loading">
        <b-container class="my-sm-0 my-lg-5">
            <b-row class="d-block d-lg-none mt-4">
                <b-col class="img-wrapper d-flex">
                    <b-skeleton no-aspect height="100px" width="70%" class="mx-auto"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col
                    sm="12"
                    lg="7"
                >
<!--                    headline-->
                    <b-skeleton width="90%" height="50px" class="mt-3"/>

                    <br />

<!--                    sub-headline-->
                    <b-skeleton width="100%" />
                    <b-skeleton width="75%" />

<!--                    CTA buttons-->
                    <b-row class="my-5 d-none d-md-block">
                        <b-col class="actions-wrapper">
                            <b-skeleton type="button" height="50px" width="20%" class="d-inline-block" />
                            <b-skeleton type="button" height="50px" width="30%" class="d-inline-block" />
                        </b-col>
                    </b-row>

                    <b-row class="my-5 d-block d-md-none">
                        <b-col class="actions-wrapper text-center">
                            <b-skeleton type="button" height="50px" width="20%" class="d-inline-block" />
                            <b-skeleton type="button" height="50px" width="30%" class="d-inline-block" />
                        </b-col>
                    </b-row>

<!--                    body-->
                    <b-skeleton width="90%" />
                    <b-skeleton width="100%" />
                    <b-skeleton width="80%" />
                    <b-skeleton width="60%" />
                    <br>
                    <br>
                    <b-skeleton width="100%" />
                    <b-skeleton width="90%" />
                    <b-skeleton width="55%" />
                    <br>
                    <b-skeleton width="30%" />
                    <b-skeleton width="15%" />
                </b-col>

                <b-col
                    cols="5"
                    class="img-wrapper d-none d-lg-block"
                >
                    <b-skeleton-img no-aspect height="250px" />
                </b-col>
            </b-row>
        </b-container>

<!--        agent info-->
        <b-skeleton no-aspect height="732px" class="mt-4" />
    </div>
</template>

<script>
    export default {
        name: "BabyOrAdoptionHomeLoading"
    };
</script>
